<template>
  <!-- TODO: On doit forcer une largeur maximal de 1600px pour les listes horizontales -->
  <div :id="content.idHTML" :class="jel_getClassObject(content)">
    <template v-if="isVisible">
      <b-container
        v-if="
          (mixinEnvironnement_inEditor || arrElementListeHorizontale.length) &&
          !isCarteListeUnElement &&
          contentTitre.titre
        "
        fluid
        class="d-flex justify-content-center px-sm-4 info-titre m-0 px-2 pt-3"
      >
        <b-row class="w-100">
          <b-col
            v-if="content.afficherZoneEscamotable === 'true'"
            cols="8"
            class="titre-liste graphik_black zoneEscamotable py-2 px-1 px-lg-2 text-left w-100"
            @click="toggleZoneEscamotable"
          >
            <Titre :content="contentTitre" />
          </b-col>
          <b-col v-else cols="8" class="titre-liste px-1 px-lg-2 graphik_black">
            <b-link
              v-if="isLienListeHorizontaleVisible"
              v-bind="jel_getLienBinding(content.lien)"
              class="d-flex"
            >
              <Titre :content="contentTitre" />
              <b-icon scale="0.7" icon="chevron-right"></b-icon>
            </b-link>
            <div v-else>
              <Titre :content="contentTitre" />
            </div>
          </b-col>
          <b-col
            v-if="content.libLien && !jel_getLienBinding(content.lien).disabled"
            class="libelle-liste text-right pr-0 pr-sm-1"
          >
            <b-link v-bind="jel_getLienBinding(content.lien)" class="graphik_medium texte-lien"
              >{{ content.libLien }}
            </b-link>
          </b-col>
        </b-row>
      </b-container>
      <template v-if="mixinEnvironnement_inEditor">
        <div class="container">
          <div class="row">
            <EditableArea
              :content="getContentEditableArea()"
              :parentTemplateId="metadata['mgnl:template']"
            />
          </div>
        </div>
      </template>

      <WithRoot :show="content.afficherZoneEscamotable === 'true'">
        <div class="panneau" :class="[zoneEscamotableOuvert ? 'd-flex' : 'd-none']">
          <vue-horizontal-list
            v-if="arrElementListeHorizontale.length"
            ref="listeHorizontale"
            :reduireItemsVHL="!isMediaImageLogoProduitCasino3x4"
            :itemMinWidth="itemMinWidth"
            :items="arrElementListeHorizontale"
            :options="getOptions()"
          >
            <template #default="{ item }">
              <component :is="item.componentName" :content="item" />
            </template>
          </vue-horizontal-list>
        </div>
      </WithRoot>
    </template>

    <div
      v-else
      v-observe-visibility="{
        callback: visibilityChanged,
        once: true,
      }"
      class="chargement"
    >
      <span> {{ $t('chargement') }} {{ content.titre }}...</span>
    </div>
  </div>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility';

import { mapGetters } from 'vuex';
import moment from 'moment';
import { EditableArea } from '@/vue-editor';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';

import VueHorizontalList from '@/components/container/liste/VueHorizontalList';
import WithRoot from '@/components/base/WithRoot';

// Trié alphabétiquement
import MediaImage from '@/components/media/image/MediaImage';
import BingoGagnantMajeur from '@/components/bingo/BingoGagnantMajeur';
import CarteListeProduitCasino from '@/components/casino/carte/CarteListeProduitCasino';
import CarteListeProduitCED from '@/components/casino/carte/CarteListeProduitCED';
import CarteProduitCasino from '@/components/casino/carte/CarteProduitCasino';
import CarteProduitCED from '@/components/casino/carte/CarteProduitCED';
import CartePromo from '@/components/base/carte/CartePromo';
import MediaImageLogoProduitCasino3x4 from '@/components/casino/media/image/MediaImageLogoProduitCasino3x4';
import Titre from '@/components/base/Titre';

export default {
  name: 'ListeHorizontale',
  components: {
    EditableArea,
    VueHorizontalList,
    WithRoot,

    // Trié alphabétiquement
    BingoGagnantMajeur,
    CarteListeProduitCasino,
    CarteListeProduitCED,
    CarteProduitCasino,
    CarteProduitCED,
    CartePromo,
    MediaImage,
    MediaImageLogoProduitCasino3x4,
    Titre,
  },
  directives: {
    ObserveVisibility,
  },
  mixins: [mixinEnvironnement],
  props: {
    metadata: { type: Object },
    content: { type: Object, required: true },
  },
  data() {
    return {
      zoneEscamotableOuvert: false,
      isVisible: null,
      itemMinWidth: 230,
      options: {
        item: {
          // css class to inject into each individual item
          class: 'd-flex',
          // padding between each item
          padding: 16,
        },
        list: {
          // css class for the parent of item
          class: 'd-flex mx-2 mx-md-3 mx-lg-4',
          // padding of the list, if container < windowed what is the left-right padding of the list
          // during full-screen mode the padding will added to left & right to centralise the item
          padding: 32, // nécessaire pour voir le début d'une autre carte
        },
        navigation: {
          // when to show navigation
          start: 576,
          color: '#000',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      getProduitCasinoFromCollectionByUuid: 'produitCollection/getByUuid',
      getProduitCasinoByUuid: 'produitCasino/getByUuid',
      getStatutProduit: 'produitCasino/getStatutProduit',
      getArrayIdProduitCasinoByProduitCollection:
        'produitCasino/getArrayIdProduitCasinoByProduitCollection',
      getArrayIdCedTableByProduitCollection: 'cedTable/getArrayIdCedTableByProduitCollection',
      getIsArchiveMode: 'menu/getIsArchiveMode',
    }),
    // Retourne la liste de tous les éléments (cartes, logos, etc...) de la liste horizontale
    arrElementListeHorizontale() {
      if (
        !this.isVisible ||
        !this.content ||
        !this.content.listeHorizontale ||
        this.content.listeHorizontale.length == 0 ||
        (this.isProduitCollection &&
          (!this.$store.state.produitCollection.liste || !this.$store.state.produitCasino.liste))
      ) {
        return [];
      }

      let arr = [];
      this.content.listeHorizontale['@nodes'].forEach((item) => {
        const component = this.content.listeHorizontale[item];
        if (component['mgnl:template'].includes('components/produit/produitCollection')) {
          let arrIdProduit;
          if (component.idProduitCollection) {
            const produitCollection = this.getProduitCasinoFromCollectionByUuid(
              component.idProduitCollection
            );
            if (component.typeAffichage.field == 'CarteProduitCED') {
              arrIdProduit = produitCollection
                ? this.getArrayIdCedTableByProduitCollection(produitCollection)
                : [];
            } else {
              arrIdProduit = produitCollection
                ? this.getArrayIdProduitCasinoByProduitCollection(produitCollection)
                : [];
            }
          } else {
            arrIdProduit = [...component.listeIdProduit];
            arrIdProduit = arrIdProduit.filter((value, index, arr) => {
              return value != '';
            });
            const arrProduitDesactive = arrIdProduit.filter(
              (Uuid) => this.getStatutProduit(this.getProduitCasinoByUuid(Uuid)).indDesactive
            );
            const arrProduitActif = arrIdProduit.filter((Uuid) => {
              // retour des elements non desactive dans le bonne ordre
              return !arrProduitDesactive.includes(Uuid);
            });
            arrIdProduit = arrProduitActif.concat(arrProduitDesactive);
          }
          if (
            !component.nbMinProduitAffiche ||
            arrIdProduit.length >= component.nbMinProduitAffiche
          ) {
            if (component.nbMaxProduitAffiche || component.nbProduitSaute) {
              // Exemple: 12 et 4 -> Afficher 12 produits et sauter les 4 premiers
              arrIdProduit = arrIdProduit.slice(
                Number(component.nbProduitSaute || null),
                Number(component.nbMaxProduitAffiche || null) +
                  Number(component.nbProduitSaute || null)
              );
            }

            let arrProduitCollection = this.getArrayElementRegroupe(
              arrIdProduit,
              component.typeAffichage
            );

            if (component?.cacherSurTitreCategorie === 'true')
              arrProduitCollection = arrProduitCollection.map((obj) => ({
                ...obj,
                cacherSurTitreCategorie: 'true',
              }));

            arr = arr.concat(arrProduitCollection);
            arr = this.filtrerDoublonProduitCourantEtDateLancement(
              arr,
              this.content.produitCourantPageJeu || null
            );
          }
        } else {
          // Extraire la dernière portion après le / du mgnl:template
          // eslint-disable-next-line prefer-destructuring
          component.componentName = /[^/]*$/.exec(component['mgnl:template'])[0];

          if (component.listeItems) {
            arr = component.listeItems;
          } else {
            arr.push(component);
            arr = this.filtrerDoublonProduitCourantEtDateLancement(
              arr,
              this.content.produitCourantPageJeu || null
            );
          }
        }
      });

      // console.log(`Durée 'arrElementListeHorizontale' = ${(Date.now() - start) / 1000}`);
      const nbMaxElementAffiche =
        this.content.nbMaxElementAffiche ??
        Number(process.env.VUE_APP_LISTE_HORIZONTALE_NB_MAX_ELEMENT_AFFICHE);

      if (arr.length > nbMaxElementAffiche) {
        arr = arr.slice(0, nbMaxElementAffiche);
      }

      arr = arr.map((obj) => ({
        ...obj,
        formatCarte: this.content.formatCarte,
        isListeHorizontale: !this.isCarteListeUnElement,
      }));

      return this.filtrerDateAffichage(arr);
    },
    isCarteListeUnElement() {
      return this.content.nbMaxElementAffiche === '1';
    },
    isMediaImageLogoProduitCasino3x4() {
      return this.arrElementListeHorizontale[0].componentName === 'MediaImageLogoProduitCasino3x4';
    },
    isProduitCollection() {
      const found = this.content.listeHorizontale['@nodes'].find((item) => {
        const component = this.content.listeHorizontale[item];
        const componentName = /[^/]*$/.exec(component['mgnl:template'])[0];
        return componentName.includes('produitCollection');
      });
      return found != undefined;
    },
    isLienListeHorizontaleVisible() {
      return !this.content.libLien && !this.jel_getLienBinding(this.content.lien).disabled;
    },
    contentTitre() {
      return {
        type: 'titre',
        titre: this.content.titre,
        classeCSS: 'p-0 graphik_black',
      };
    },
  },
  mounted() {
    this.isVisible = this.mixinEnvironnement_inEditor;

    this.options.isCarteListeUnElement = this.isCarteListeUnElement;
    this.options.classeCssConteneur = this.content.classeCssConteneur;
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
    // Retourne un tableau d'éléments regroupés (liste 1 ou 2 colonnes par exemple)
    getArrayElementRegroupe(arrIdProduit, typeAffichage) {
      const arrProduit = [];
      const componentName = typeAffichage.field;

      if (['CarteListeProduitCasino', 'CarteListeProduitCED'].includes(componentName)) {
        const { nbColonne } = typeAffichage;
        const { nbLigne } = typeAffichage;
        const nbElementParGroupe = nbColonne == 1 ? nbLigne ?? 5 : (nbLigne ?? 2) * 2;
        const titreCarte = this.isCarteListeUnElement ? this.content.titre : null;
        const lienCarte = this.isCarteListeUnElement ? this.content.lien : null;

        const arrElementRegroupe = groupArr(arrIdProduit, nbElementParGroupe);
        arrElementRegroupe.forEach((item) => {
          arrProduit.push({
            componentName: 'CarteListeProduitCasino',
            listeIdProduit: item,
            nbColonne,
            nbLigne,
            titre: titreCarte,
            lien: lienCarte,
          });
        });
      } else {
        arrIdProduit.forEach((item) => {
          arrProduit.push({
            componentName,
            idProduit: item,
          });
        });
      }

      return arrProduit;
    },
    getContentEditableArea() {
      const contentEditableArea = this.content.listeHorizontale;
      contentEditableArea.classeCSS += ' col-3';
      return contentEditableArea;
    },
    getOptions() {
      const totalListPadding = this.options.list.padding * 2;
      const sizeMobile = this.isMediaImageLogoProduitCasino3x4 ? 4 : 1;
      this.options.responsive = [
        // responsive breakpoints to calculate how many items to show in the list at each width interval
        // it will always fall back to these:
        // Puisque le padding de la liste est négatif, il doit être soustrait pour avoir les bons breakpoints
        // Les valeurs 575 et 1072 sont les valeurs du width de la div avec la classe vhl-list à ce breakpoint-ci.
        {
          end: 575 - totalListPadding,
          size: sizeMobile,
        },
        {
          start: 575 - totalListPadding,
          end: 1072 - totalListPadding,
          size: this.content.nbColTablette ?? 3,
        },
        {
          start: 1072 - totalListPadding,
          size: this.content.nbColDesktop ?? 4,
        },
      ];

      if (this.content.defilementAutomatique === 'true') {
        this.options.autoplay = { play: true, repeat: true, speed: 5000 };
      }
      return this.options;
    },
    filtrerDoublonProduitCourantEtDateLancement(arr, produitCourantPageJeu) {
      // TODO: Gérer le cas dans les listes
      return arr.filter((element, index, self) => {
        const prod = this.getProduitCasinoByUuid(element.idProduit);
        const maintenant = moment().tz('America/Montreal', true);
        let debut = null;
        if (prod && prod.dateLancement) {
          debut = moment(prod.dateLancement).tz('America/Montreal', true)
            ? moment(prod.dateLancement).tz('America/Montreal', true)
            : null;
        } else {
          debut = moment().subtract(7, 'days');
        }
        return (
          index ===
            self.findIndex(
              (e) =>
                (e.idProduit && e.idProduit == element.idProduit) ||
                JSON.stringify(e) === JSON.stringify(element)
            ) &&
          element.idProduit !== produitCourantPageJeu &&
          maintenant.isAfter(debut)
        );
      });
    },
    filtrerDateAffichage(arr = null) {
      const activeArray = [];
      const archiveArray = [];

      const maintenant = moment().tz('America/Montreal', true);
      if (arr.length == 0) return [];

      for (let i = 0; i < arr.length; i++) {
        let momentDebut;
        let momentFin;

        if (arr[i].dateDebut) {
          momentDebut = moment(arr[i].dateDebut).tz('America/Montreal', true);
        }
        if (arr[i].dateFin) {
          momentFin = moment(arr[i].dateFin).tz('America/Montreal', true);
        }

        if (
          (momentDebut && maintenant.isBefore(momentDebut)) ||
          (momentFin && maintenant.isAfter(momentFin))
        ) {
          archiveArray.push(arr[i]);
        } else {
          activeArray.push(arr[i]);
        }
      }

      if (this.getIsArchiveMode) {
        return archiveArray;
      }
      return activeArray;
    },
    toggleZoneEscamotable() {
      this.zoneEscamotableOuvert = !this.zoneEscamotableOuvert;
    },
  },
};

function groupArr(data, n) {
  const group = [];
  for (let i = 0, j = 0; i < data.length; i++) {
    if (i >= n && i % n === 0) j++;
    group[j] = group[j] || [];
    group[j].push(data[i]);
  }
  return group;
}
</script>

<style lang="scss" scoped>
.chargement {
  // Fixer un espace pour permettre le lazy loading
  min-height: 100vh;
}
div.vue-horizontal-list {
  overflow: hidden;
  // ::v-deep div.vhl-container div.vhl-list {
  //   padding-right: 3rem;
  // }

  ::v-deep {
    .vhl-btn-right {
      margin-right: 10px;
    }
    .vhl-btn-left {
      margin-left: 10px;
    }
  }
}

.info-titre {
  ::v-deep .titre {
    font-size: $font-size-8;
    line-height: $line-height-10;
    @include media-breakpoint-up(sm) {
      font-size: $font-size-9;
      line-height: $line-height-11;
    }
  }
}

.libelle-liste {
  font-size: 1rem;
  ::v-deep a {
    color: $gris-casino;
    padding: 4px;
    &:focus-visible {
      background-color: $bleu-pale-casino;
      border-radius: 4px;
      outline: none;
    }
  }
}

div.info-titre {
  background: inherit;
}

.zoneEscamotable {
  cursor: pointer;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  outline: none;
  &:hover {
    background-color: #ccc;
  }
}
.panneau {
  background-color: transparent;
}
.titreListe ::v-deep .titre {
  font-size: 1.125rem;
  line-height: 1.25rem;
  @include media-breakpoint-up(md) {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
}

.texte-lien {
  font-size: 0.8125rem;
  line-height: 0.8125rem;
}
</style>
